import { render, staticRenderFns } from "./rentaTable.vue?vue&type=template&id=20cd8af8&"
import script from "./rentaTable.vue?vue&type=script&lang=js&"
export * from "./rentaTable.vue?vue&type=script&lang=js&"
import style0 from "./rentaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports